import React from 'react';
import { createRoot } from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import ScrollToTop from './shared/components/scrollToTop/ScrollToTop'

import { ThemeWrap } from "./uiTheme";

import './index.css';
import './assets/scss/styles.scss';
import App from './App';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ThemeWrap>
      <ScrollToTop />
      <App />
    </ThemeWrap>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
